// extracted by mini-css-extract-plugin
export default {"root":"InfoBox_root__wBxOh","desc":"InfoBox_desc__vhf-7"};